Ext.define('SA.CanvasRenderer', {
    constructor(canvas = SA.Html.create({type: 'canvas'})) {
        this.cx = canvas.getContext('2d');
    },

    drawImage({source, x = 0, y = 0, width, height}) {
        if (width !== undefined || height !== undefined) {
            this.cx.drawImage(source, x, y, width, height);
        }
        else {
            this.cx.drawImage(source, x, y);
        }
    },

    drawRect({fill, stroke, x, y, width, height}) {
        if (fill) {
            this.cx.fillStyle = fill;
            this.cx.fillRect(x, y, width, height);
        }

        if (stroke) {
            this.cx.strokeStyle = stroke;
            this.cx.strokeRect(x, y, width, height);
        }
    },

    getCanvas() {
        return this.cx.canvas;
    },

    render({width, height, content, background}) {
        this.cx.canvas.width = width;
        this.cx.canvas.height = height;

        this.cx.clearRect(0, 0, this.cx.canvas.width, this.cx.canvas.height);

        if (background) {
            this.cx.fillStyle = background;
            this.cx.fillRect(0, 0, this.cx.canvas.width, this.cx.canvas.height);
        }

        Ext.Array.from(content).forEach(({type, ...properties}) => this[`draw${Ext.String.capitalize(type)}`](properties));

        return this;
    }
});